<template>
  <div>
    <div
      v-if="headerLine"
      class="header-line"
    >
      <div class="fs22">
        {{ $t("briefcase.escrowWithdrawalTabLabel") }}
      </div>
      <RouterLink
        :to="{ path: '/my-assets', query: { selectedTitle: $t('briefcase.escrowWithdrawalTabLabel') }}"
      >
        {{ $t('briefcase.allEscrow') }}
      </RouterLink>
    </div>

    <div class="content-line">
      <UTable
        class="briefcase-table briefcase-table-hiddable"
        :items="itemsModify"
        :columns="tableColumns"
        :loading="itemLoading"
        :text-no-data="$t('briefcase.noData')"
      >
        <!-- Слот для колонки с названием -->
        <template #name="{ value }">
          <div class="block-name project-colum">
            <div class="explain uppercase">
              {{ value.name }} / {{ value.apr }}%
            </div>
          </div>
        </template>

        <!-- Слот для колонки с суммой -->
        <template #amount="{ value }">
          <span>{{ value.amount }}</span> <span>{{ value.mnemonicEng }}</span>
        </template>

        <!-- Слот для колонки с заработанным -->
        <template #earned="{ value }">
          <AuDecimalStatic
            :value="value.earned"
            :decimal="value.decimal"
            :show-addition="false"
          />
          <span>{{ value.mnemonicEng }}</span>
        </template>

        <!-- Слот для колонки с днями до выхода -->
        <template #daysToRelease="{ value }">
          <div class="block-name">
            <div class="link-text">
              {{ value.daysToRelease }}
            </div>
          </div>
        </template>

        <!-- Слот для колонки с датой выхода -->
        <template #releaseDate="{ value }">
          <div class="block-name">
            <div class="link-text">
              {{ value.releaseDate }}
            </div>
          </div>
        </template>

        <!-- Слот для колонки с действием (кнопка Withdraw) -->
        <template #action="{ value }">
          <div class="btn-block">
            <AuButton
              :disabled="!value.status"
              center
              font-size="11px"
              width="78px"
              height="31px"
              padding-horizontal="10px"
              type="primary"
              @click="openModal(value)"
            >
              {{ $t("briefcase.withdraw") }}
            </AuButton>
          </div>
        </template>
      </UTable>
    </div>

    <!-- for mobile -->
    <div class="briefcase-accordion">
      <div v-if="items != 0">
        <AuAccordion
          v-for="(item, index) in itemsModify"
          :key="item.id || index"
          :last-child="(index == items?.length - 1)"
        >
          <template #title>
            <div class="block-name">
              <div class="link-text">
                {{ item.name.name }} / {{ item.name.apr }}%
              </div>
            </div>
          </template>
          <template #content>
            <div class="content-info container-fluid">
              <div class="row">
                <div class="col info-title">
                  <span>{{ $t("briefcase.amount") }}</span>
                </div>
                <div class="col right">
                  {{ item.amount.amount }} {{ item.amount.mnemonicEng }}
                </div>
              </div>

              <div class="row">
                <div class="col info-title">
                  <span>{{ $t("briefcase.earned") }}</span>
                </div>
                <div class="col right">
                  <AuDecimalStatic
                    :value="item.earned.earned"
                    :decimal="item.earned.decimal"
                    :show-addition="false"
                  />
                  {{ item.earned.mnemonicEng }}
                </div>
              </div>

              <div class="row">
                <div class="col info-title">
                  <span>{{ $t("briefcase.daysToRelease") }}</span>
                </div>
                <div class="col right">
                  {{ item.daysToRelease.daysToRelease }}
                </div>
              </div>

              <div class="row">
                <div class="col info-title">
                  <span>{{ $t("briefcase.releaseDate") }}</span>
                </div>
                <div class="col right">
                  {{ item.releaseDate.releaseDate }}
                </div>
              </div>

              <div class="row">
                <div class="col buttons">
                  <AuButton
                    width="100%"
                    :disabled="!item.action?.status"
                    center
                    @click="openModal(item?.action)"
                  >
                    {{ $t("briefcase.withdraw") }}
                  </AuButton>
                </div>
              </div>
            </div>
          </template>
        </AuAccordion>
      </div>

      <span v-else-if="items?.length == 0">
        {{ $t('briefcase.noData') }}
      </span>

      <ProgressLoader
        v-if="itemLoading"
        mode="indeterminate"
        color="#5AC396"
        size="150px"
      />
    </div>

    <AuPagination
      v-if="totalItems > itemsPerPage && isPagination"
      :hide="itemLoading"
      :total-items="totalItems"
      @pageChanged="pageChanged"
    />

    <AuModal
      v-model="confirmDialog"
      width="380px"
    >
      <template #header>
        <span class="modal_head_text">
          {{ $t("briefcase.confirmWD") }}
        </span>
      </template>
      <template #body>
        <span>
          {{ $t("briefcase.confirmTextWD") }}
        </span>
      </template>
      <template #footer>
        <div class="footer-buttons">
          <AuButton
            bordered
            center
            width="80px"
            @click="confirmWD"
          >
            {{ $t("counterparties.deleteDialog.agree") }}
          </AuButton>
          <AuButton
            bordered
            center
            width="80px"
            @click="closeModal"
          >
            {{ $t("counterparties.deleteDialog.cancel") }}
          </AuButton>
        </div>
      </template>
    </AuModal>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import ProgressLoader from "@/loaders/progress-bar";
import UTable from "@/components/uikit/uComponents/UTable.vue";
import { mapActions, mapGetters } from "vuex";
import { timeToRelease } from "@/help/timerSupport.js";

export default {
  components: {
    ProgressLoader,
    UTable
  },
  props: {
    itemsPerPage: {
      type: Number,
      default: 30
    },
    headerLine: {
      type: Boolean,
      default: false
    },
    isPagination: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      confirmDialog: false,
      modalData: null,
      pageId: 1,
      itemLoading: true,
      items: null,
      totalItems: null,
      showMenu: []
    };
  },

  computed: {
    ...mapGetters({
      language: "language",
      profile: "profile/profile",
      requestsToIssue: "requestsToIssue"
    }),

    isRoleExpert() {
      return Object.values(this.profile?.roles).includes("ROLE_EXPERT");
    },

    // Computed колонки для UTable
    tableColumns() {
      return [
        {
          property: "name",
          header: this.$t("briefcase.name"),
          align: "start"
        },
        {
          property: "amount",
          header: this.$t("briefcase.amount"),
          align: "center"
        },
        {
          property: "earned",
          header: this.$t("briefcase.earned"),
          align: "center"
        },
        {
          property: "daysToRelease",
          header: this.$t("briefcase.daysToRelease"),
          align: "center"
        },
        {
          property: "releaseDate",
          header: this.$t("briefcase.releaseDate"),
          align: "center"
        },
        {
          property: "action",
          header: this.$t("briefcase.action"),
          align: "center"
        }
      ];
    },

    itemsModify() {
      return _.map(this.items, (item, i) => {
        // Создаем уникальный ID для каждого элемента
        const itemId = item?.id || `stacking-${i}-${Date.now()}`;

        return {
          id: itemId,
          name: {
            name: `${item?.auCapital?.lockUpTerm} days`,
            apr: this.apr(item?.auCapital?.expectedProfit)
          },
          amount: {
            amount: item?.value,
            decimal: item?.tokenQuote?.decimals,
            indent: item?.tokenQuote?.indent,
            mnemonicEng: item?.tokenQuote?.mnemonicEng
          },
          earned: {
            earned: item?.earned,
            decimal: item?.tokenQuote?.decimals,
            indent: item?.tokenQuote?.indent,
            mnemonicEng: item?.tokenQuote?.mnemonicEng
          },
          daysToRelease: {
            daysToRelease: timeToRelease({ dateToRelesse: item?.releaseDate })
          },
          releaseDate: {
            releaseDate: this.formatDateRange(item?.releaseDate)
          },
          action: {
            id: item?.id,
            status: item?.isWithdrawalAllowed,
            amount: item?.value,
            earned: item?.earned,
            index: i,
            // Добавляем данные для модального окна
            modalData: {
              id: item?.id,
              value: item?.value,
              earned: item?.earned,
              tokenQuote: item?.tokenQuote
            }
          }
        };
      });
    },

    isLightTheme() {
      return this.$store.getters.isLightTheme;
    }
  },

  async mounted() {
    await this.getItems();
    this.closeAllMenus();
  },

  methods: {
    ...mapActions({
      getStackingPool: "getStackingPool",
      sendTokenEventsWithdraw: "sendTokenEventsWithdraw"
    }),

    apr(value) {
      return Number((value / 10).toFixed(1));
    },

    async openModal(actionData) {
      // Сохраняем все необходимые данные для модального окна
      this.modalData = {
        id: actionData.id,
        value: actionData.amount,
        earned: actionData.earned,
        tokenQuote: actionData.tokenQuote
      };
      this.confirmDialog = true;
    },

    async closeModal() {
      this.modalData = null;
      this.confirmDialog = false;
    },

    async getItems() {
      this.itemLoading = true;
      const params = {
        page: this.pageId,
        itemsPerPage: this.itemsPerPage,
        type: "token_capital_buy",
        applicationType: "stakingPool",
        hasWithdrawalDate: false
      };

      try {
        const { data, totalItems } = await this.getStackingPool(params);
        this.items = data;
        this.totalItems = totalItems;
      }
      catch (error) {
        console.log(error);
      }
      finally {
        this.itemLoading = false;
        this.closeAllMenus();
      }
    },

    async pageChanged(actualPage) {
      this.pageId = actualPage;
      this.getItems();
    },

    formatDateRange(startDate) {
      if (!startDate) {
        return "";
      }

      const formatMonth = (date) => {
        if (this.language === "ru") {
          return moment(date)
            .locale("ru")
            .format("DD MMM YYYY HH:mm")
            .replace(/\./, "")
            .replace(/[а-я]+/g, (month) => month.charAt(0).toUpperCase() + month.slice(1));
        }
        return moment(date).locale("en").format("DD MMM YYYY HH:mm");
      };
      return formatMonth(startDate);
    },

    closeAllMenus() {
      this.showMenu = _.map(this.items, () => false);
    },

    openMenu(index) {
      this.closeAllMenus();
      this.showMenu[index] = true;
    },

    async confirmWD() {
      if (!this.modalData?.id) {
        this.showError(this.$t("briefcase.messages.errorWd"));
        return;
      }

      this.itemLoading = true;
      this.confirmDialog = false;

      const params = {
        tokenEvent: `/api/token_events/${this.modalData.id}`
      };

      try {
        const resp = await this.sendTokenEventsWithdraw(params);
        if (resp?.status == 200 || resp?.status == 201) {
          this.showSuccess(this.$t("briefcase.messages.successWd"));
          // Обновляем данные после успешного вывода
          setTimeout(() => {
            this.getItems();
          }, 2000);
        }
        else {
          this.showError(resp?.data?.message || this.$t("briefcase.messages.errorWd"));
        }
      }
      catch (error) {
        this.showError(error?.message || this.$t("briefcase.messages.errorWd"));
      }
      finally {
        this.itemLoading = false;
        this.closeAllMenus();
        this.modalData = null;
      }
    },

    showSuccess(message) {
      this.$toast.success(message);
    },

    showError(message) {
      this.$toast.error(message);
    }
  }

};
</script>

<style scoped lang="scss">
.header-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  a {
    padding-top: 4px;
    font-size: 13px;
    color: #279063;
    text-decoration: none;
  }
}
.briefcase {
  &-info {
    padding: 11px 20px 0 18px;

    .title {
      font-weight: 600;
      font-size: 24px;
      color: var(--text-color);
      margin-bottom: 30px;
    }
  }

  &-table {
    margin-top: 10px;
    margin-bottom: 10px;

    &-hiddable {
      @media screen and (max-width:590px) {
        display: none;
      }
    }
  }

  &-accordion {
    margin-top: 10px;
    display: none;

    @media screen and (max-width:590px) {
      display: block;
    }
  }
}

.spot-balance {
  color: var(--color-50);
  font-weight: 500;
  font-size: 12px;
}

.content {
  &-header {
    color: var(--text-color);
    font-size: 12px;
  }

  &-info {
    color: var(--text-color);
    display: flex;
    padding-right: 0;
    padding-left: 0;
    flex-direction: column;
    gap: 20px;

    &-title {
      color: var(--color-60)
    }

    .row {
      font-weight: 450;
      font-size: 12px;

      .col:last-child {
        text-align: end;
      }

      .buttons {
        display: flex;
        flex-direction: column;
        gap: 10px;
      }
    }
  }
}

.icon-with-bg {
  width: 25px;
  height: 25px;
  margin-right: 8px;
  opacity: var(--opacity);
}

.link-container {
  display: flex;
  align-items: center;
}

.link {
  &:hover {
    cursor: pointer;
  }
  display: flex;
  align-items: center;
  .block-name {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 130px;
    .link-text {
      &:hover {
        text-decoration: underline;
        text-decoration-thickness: 1px;
        text-decoration-color: var(--color-00);
        text-decoration-style: dashed;
        text-underline-offset: 4px;
      }
    }
    .explain {
      font-weight: 450;
      font-size: 12px;
      color: var(--color-60);
      @media screen and (max-width:384px) {
        line-height: 1.1;
      }
    }
  }
}
.briefcase-tooltip {
  margin-left: 2px;
}
.t-image {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 10px;
  &:hover {
    cursor: pointer;
  }
}
.progress_line {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.progress_text {
  display: flex;
  justify-content: space-between;
  font-weight: 450;
  font-size: 12px;
  color: var(--color-20);
}
.indent_progress {
  margin-top: 6px;
  width: 100%;
}
.status {
  width: 135px;
}
.uppercase::first-letter {
  text-transform: uppercase;
}
.order-empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .image {
    width: 400px;
    height: 300px;
  }
}
.right {
  text-align: end;
}
.container-menu{
  position: relative;
}
.context-menu {
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 128px;
  right: calc(50% - 128px / 2);
  background: var(--menu-color);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  z-index: 10;
  top: 30px;
}
.project-colum {
  width: 130px;
}
.footer-buttons {
  margin-top: 20px;
  display: flex;
  justify-content: end;
  gap: 8px;
}

.btn-block {
  width: 100%;
  display: flex;
  justify-content: center;
}

.briefcase-table-hiddable {
  @media screen and (max-width:670px) {
    display: none;
  }
}
</style>